<div class="form-group" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div>
    <form [formGroup]="addressForm">
      <p class="d-flex">
        <input nbInput fullWidth formControlName="address" placeholder="Адрес">
        &nbsp;
        <button class="chooseButton" i18n="@@ChooseAddressButton" nbButton size="small" type="button" (click)="openChooseAddressModal()">Выбрать адрес</button>
      </p>
      <p>
        <input fieldSize="tiny" nbInput formControlName="latitude" i18n-placeholder="@@LatitudePlaceholder" placeholder="Широта">
        &nbsp;
        <input fieldSize="tiny" nbInput formControlName="longitude" i18n-placeholder="@@LongitudePlaceholder" placeholder="Долгота">
      </p>
    </form>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
